module.exports = __webpack_public_path__ + "img/track.1f120aba.png";